/**
 * @name JobChangeService
 * @description Servicio para gestionar del cambio de puesto
 * @author Alexis Becerra
 */

import axios from 'axios';
import { Environment } from '@config';

// URL Organigrama Endpoint
const BASE_URL = `${Environment.getCurrent().endpoints.orgChart}`;

/**
 * Consulta los cambios de puestos del mimo empleado
 * @return {any} promise 
 */
const getData = () => {
    let URL = `${BASE_URL}/Administracion/SolicitudPuesto`;
    return axios.get(URL).then(({ data }) => {
        return data;
    });
};

/**
 * Consulta los cambios de puestos por revisar
 * @return {any} promise 
 */
const getDataPending = (request) => {
    let URL = `${BASE_URL}/Administracion/SolicitudPuestoAutorizar?IdEmpleado=${request}`;
    return axios.get(URL).then(({ data }) => {
        return data;
    });
};

/**
 * Añade una solicitud de cambio de puesto
 * @param {any} request { IdEmpleado, IdPuesto }
 * @return {any} promise
 */
const post = (request) => {
    let URL = `${BASE_URL}/Administracion/SolicitudPuesto`;
    return axios.post(URL, request).then(({ data }) => {
        return data;
    });
};

/**
 * Actualiza el estatus de una solicitud de cambio de puesto 
 * @param {any} request { IdEmpleado, IdPuesto, Comentario }
 * @param {any} tipo { 1 = Aprovado. 0 = Rechazado }
 * @return {any} promise
 */
const put = (tipo, request) => {
    let URL = `${BASE_URL}/Administracion/SolicitudPuesto?tipo=${tipo}`;
    return axios.put(URL, request).then(({ data }) => {
        return data;
    });
};

export const JobChangeService = {
    getData,
    getDataPending,
    post,
    put
};